import { render, staticRenderFns } from "./GStudentRecordRecommendationLetterList.vue?vue&type=template&id=7ca9f5da&scoped=true&"
import script from "./GStudentRecordRecommendationLetterList.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordRecommendationLetterList.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordRecommendationLetterList.vue?vue&type=style&index=0&id=7ca9f5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca9f5da",
  null
  
)

export default component.exports